if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.viewer) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      if (this.elements.thumbnails) {
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
        });
        if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
      }
      // Autoplay video in the initially active slide, then preload all other videos on page load
      const initialActive = this.elements.viewer.querySelector('.product__media-item.is-active');
      if (initialActive) {
        requestAnimationFrame(() => {
          this.playActiveMedia(initialActive);
          window.setTimeout(() => this.preloadAllSlides(initialActive), 200);
        });
      }
    }

    preloadAllSlides(activeSlide) {
      const slides = this.elements.viewer.querySelectorAll('.product__media-item');
      let delay = 0;
      const staggerMs = 80;
      slides.forEach((slide) => {
        if (slide === activeSlide) return;
        if (!slide.querySelector('.deferred-media')) return;
        window.setTimeout(() => this.preloadSlide(slide), delay);
        delay += staggerMs;
      });
    }

    onSlideChanged(event) {
      if (event.detail.currentElement == undefined) return;

      this.playActiveMedia(event.detail.currentElement);
      const thumbnail = this.elements.thumbnails && this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      if (thumbnail) this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
        element.classList.remove('is-active');
        element.querySelector('button').removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = theme.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (!deferredMedia) return;
      if (deferredMedia.getAttribute('loaded')) {
        this.resumeMediaInDeferred(deferredMedia);
      } else {
        deferredMedia.loadContent(false);
        window.setTimeout(() => {
          this.ensureVideoLoops(deferredMedia);
         this.resumeMediaInDeferred(deferredMedia);
          this.resumeAllOtherVideos(activeItem);
        }, 150);
      }
      this.resumeAllOtherVideos(activeItem);
      this.preloadAdjacentSlides(activeItem);
    }

    resumeAllOtherVideos(activeItem) {
      const slides = this.elements.viewer.querySelectorAll('.product__media-item');
      slides.forEach((slide) => {
        if (slide === activeItem) return;
        const dm = slide.querySelector('.deferred-media[loaded]');
        if (dm) this.resumeMediaInDeferred(dm);
      });
    }

    ensureVideoLoops(deferredMedia) {
      const video = deferredMedia && deferredMedia.querySelector('video');
      if (!video) return;
      video.loop = true;
      video.removeEventListener('ended', video._galleryLoopHandler);
      video._galleryLoopHandler = () => video.play();
      video.addEventListener('ended', video._galleryLoopHandler);
    }

    resumeMediaInDeferred(deferredMedia) {
      const video = deferredMedia.querySelector('video');
      if (video) {
        video.loop = true;
        if (!video._galleryLoopHandler) {
          video._galleryLoopHandler = () => video.play();
          video.addEventListener('ended', video._galleryLoopHandler);
        }
        video.play().catch(() => {});
        return;
      }
      const yt = deferredMedia.querySelector('iframe.js-youtube');
      if (yt && yt.contentWindow) {
        try {
          yt.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        } catch (e) {}
        return;
      }
      const vimeo = deferredMedia.querySelector('iframe.js-vimeo');
      if (vimeo && vimeo.contentWindow) {
        try {
          vimeo.contentWindow.postMessage('{"method":"play"}', '*');
        } catch (e) {}
      }
    }

    preloadAdjacentSlides(activeSlide) {
      const slides = this.elements.viewer.querySelectorAll('.product__media-item');
      const index = Array.from(slides).indexOf(activeSlide);
      if (index === -1) return;
      [index - 1, index + 1].forEach((i) => {
        if (i < 0 || i >= slides.length) return;
        this.preloadSlide(slides[i]);
      });
    }

    preloadSlide(slide) {
      const deferredMedia = slide.querySelector('.deferred-media');
      if (!deferredMedia || deferredMedia.getAttribute('loaded')) return;
      deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
